import settings from "../settings";
import { getErrorMessage } from "./index";
import { constructAdminAPIEndPoint, fetchHandler } from "./index";

export const getEmbedUserInfo = (userData, orgData) => {
  console.log(settings.PORTAL_ENV);
  const isNonProd = settings.PORTAL_ENV !== "prod";
  return {
    emailId: isNonProd ? userData[0].email : `px-portal@${orgData.id}.com`,
    firstName: isNonProd ? userData[0].name.split(".")[0] : orgData.name,
    lastName: isNonProd ? userData[0].name.split(".")[1] : "Embed",
  };
};

export const getEmbedPermissions = (isInvalidSuperUser) => {
  const basePermissions = [
    "access_data",
    "clear_cache_refresh",
    "see_lookml_dashboards",
    "download_without_limit",
    "see_drill_overlay",
  ];

  const superuserPermissions = [
    "see_looks",
    "see_user_dashboards",
    "explore",
    "create_table_calculations",
    "create_custom_fields",
    "can_create_forecast",
    "save_content",
    "send_outgoing_webhook",
    "send_to_s3",
    "send_to_sftp",
    "schedule_look_emails",
    "schedule_external_look_emails",
    "send_to_integration",
    "create_alerts",
    "download_with_limit",
    "see_sql",
  ];

  return isInvalidSuperUser
    ? [...basePermissions, ...superuserPermissions]
    : basePermissions;
};

export const getEmbedUrl = async ({
  userData,
  orgData,
  isInvalidSuperUser,
  embedPath,
  errorMessageKey = "dashboard",
  additionalUserAttributes = {},
  lookerModels = ["pub_views"],
}) => {
  const { emailId, firstName, lastName } = getEmbedUserInfo(userData, orgData);
  const permissions = getEmbedPermissions(isInvalidSuperUser);

  try {
    const response = await fetchHandler({
      method: "POST",
      url: constructAdminAPIEndPoint({ url: "looker/get_embed_url" }),
      headers: {
        "cache-control": "no-cache, no-store",
      },
      body: {
        user_id: emailId,
        first_name: firstName,
        last_name: lastName,
        dashboard_url: embedPath,
        org_id: orgData.id,
        permissions: permissions,
        looker_models: lookerModels,
        group_ids: [],
        user_attributes: { email: emailId, ...additionalUserAttributes },
      },
      errorMessage: getErrorMessage(errorMessageKey),
    });

    return response?.url;
  } catch (error) {
    console.error("Error getting embed URL:", error);
    throw error;
  }
};
